<div class="drawer-form-wrapper without-scroll without-bottom-cta">
  <div class="header-with-cta mb-24">
    <form
      [formGroup]="form"
      nz-form
      class="form"
      nzLayout="horizontal"
      (ngSubmit)="changeFilter()">
      <div class="form-grid-secondary">
        <nz-form-item>
          <nz-form-label nzFor="datasheet">Datasheet</nz-form-label>
          <nz-form-control>
            <nz-select
              nzSuffixIcon
              nzShowSearch
              nzAllowClear
              nzPlaceHolder="Select datasheet"
              name="datasheet"
              formControlName="datasheet"
              [nzOptionOverflowSize]="7">
              <nz-option
                *ngFor="let item of datasheetData"
                [nzLabel]="item.value"
                [nzValue]="item.id"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="graph">Graph</nz-form-label>
          <nz-form-control>
            <nz-select
              nzSuffixIcon
              nzShowSearch
              nzPlaceHolder="Select graph"
              formControlName="graph"
              name="graph"
              [nzOptionOverflowSize]="7">
              <nz-option
                nzLabel="Frequency / Duration"
                [nzValue]="1"></nz-option>
              <nz-option nzLabel="Frequency Interval" [nzValue]="2"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>

      <app-graph-filter
        (filterChange)="onFilterChange($event)"></app-graph-filter>
      <button
        nz-button
        class="apply-button"
        type="submit"
        nzType="primary"
        [disabled]="form.invalid">
        Apply
      </button>
    </form>
  </div>

  <div class="header-with-cta mb-24 without-border">
    <h3 class="title s-18">{{ getTitle() }}</h3>
    <div class="cta-wrapper">
      <button
        nz-button
        type="reset"
        nzType="default"
        (click)="printGraph()"
        [disabled]="(!isGraphDataAvailable && !graphData) || isLoading"
        [nzLoading]="isPrintLoading">
        <svg-icon
          [title]="'Print Graph'"
          src="/assets/icon/icon-printer.svg"
          class="icon s-20"></svg-icon>
        Print
      </button>
      <button
        *ngIf="value('datasheet') !== 3"
        nz-button
        type="reset"
        nzType="default"
        (click)="openTreatmentPhasesDrawer()">
        Treatment Phases
      </button>
    </div>
  </div>

  <nz-spin [nzSpinning]="isLoading">
    <div class="graph-content">
      <app-partial-interval-graph
        *ngIf="
          isGraphDataAvailable && partialIntervalGraphData && selectedUnit === 3
        "
        [graphData]="partialIntervalGraphData"
        (allChartImage)="onAllChartImagesRenderd($event, 'avg')"
        (allChartTotalImage)="onAllChartImagesRenderd($event, 'total')"
        (chartImage)="onChartImageGenerated($event, 'avg')"
        (chartTotalImage)="
          onChartImageGenerated($event, 'total')
        "></app-partial-interval-graph>
      <app-latency-graph
        *ngIf="isGraphDataAvailable && latencyGraphData && selectedUnit === 2"
        [graphData]="latencyGraphData"
        (allChartImage)="onAllChartImagesRenderd($event)"
        (chartImage)="onChartImageGenerated($event)"></app-latency-graph>
      <app-frequency-datasheet-graph
        *ngIf="
          isGraphDataAvailable &&
          frequencyDatasheetGraphData &&
          selectedUnit === 1 &&
          selectedGraph === 1
        "
        [graphData]="frequencyDatasheetGraphData"
        (allChartImage)="onAllChartImagesRenderd($event)"
        (chartImage)="
          onChartImageGenerated($event)
        "></app-frequency-datasheet-graph>
      <app-frequency-interval-graph
        *ngIf="
          isGraphDataAvailable &&
          frequencyIntervalGraphData &&
          selectedUnit === 1 &&
          selectedGraph === 2
        "
        [graphData]="frequencyIntervalGraphData"
        (allChartImage)="onAllChartImagesRenderd($event)"
        (chartImage)="
          onChartImageGenerated($event)
        "></app-frequency-interval-graph>
      <app-replacement-behavior-graph
        *ngIf="
          isGraphDataAvailable && replacementGraphData && selectedUnit === 4
        "
        [graphData]="replacementGraphData"
        (allChartImage)="onAllChartImagesRenderd($event)"
        (chartImage)="
          onChartImageGenerated($event)
        "></app-replacement-behavior-graph>
      <ng-container *ngIf="!displayNoData && isGraphDataAvailable">
        <div class="graph-note">
          💡 Tip: You can zoom in or out directly on the graph for better
          visibility. Drag left or right on the chart to navigate across the
          timeline.
        </div>
        <div class="print-note">
          🖨️ Note: Only the currently visible portion of the graph will be
          printed.
        </div>
      </ng-container>
      <app-no-data
        *ngIf="displayNoData"
        [title]="'No Data'"
        [desc]="'No Data for Graph'"
        [icon]="'/assets/icon/icon-face-happy.svg'">
      </app-no-data>
    </div>
  </nz-spin>
</div>
